import ImageStrapi, {
  ImageStrapiProps,
} from '@/components/atoms/Image/ImageStrapi';
import { Text } from '@/components/atoms/Text';
import { cn } from '@/lib/utils';

type Props = {
  icon: ImageStrapiProps;
  title: string;
  subtitle?: string;
  isCardFullWidth?: boolean;
};
export default function ProductCardTitle({
  icon,
  title,
  subtitle,
  isCardFullWidth,
}: Props) {
  return (
    <>
      <div className='flex items-center gap-2 mb-2'>
        <ImageStrapi
          block={{ ...icon }}
          inner={{ classNames: { image: 'w-6 h-6' } }}
        />
        <Text
          color='gray-600'
          variant='body-m-medium'
          classNames={{ wrapper: 'dark:text-gray-dark-400' }}
        >
          {title}
        </Text>
      </div>
      {subtitle && (
        <Text
          variant='h3'
          classNames={{
            wrapper: cn('font-serif', isCardFullWidth ? 'mb-6' : 'mb-4'),
          }}
        >
          {subtitle}
        </Text>
      )}
    </>
  );
}
